import { createStore, compose, applyMiddleware } from 'redux';

import { reduxSagaMiddleware, reduxLoggerMiddleware } from '../middleware';
import { lastActionMiddleware } from '../middleware/getLastAction';
import monitorReducerEnhancer from '../enhancers/monitorReducer';
import staticReducers from '../reducers';
import rootSaga from '../sagas';
import createReducerManager from './createReducerManager';
import addDynamicReducers from './addDynamicReducers';

const configureStore = (preloadedState) => {
  const reducerManager = createReducerManager(staticReducers);
  let middleware = [reduxSagaMiddleware, lastActionMiddleware];
  let enhancers = [];
  let composeEnhancers = compose;

  if (process.env.REDUX_EXTENSIONS === 'enabled') {
    middleware = [...middleware, reduxLoggerMiddleware];
    enhancers = [...enhancers, monitorReducerEnhancer];
    composeEnhancers = typeof window === 'object'
      && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true,
      }) : compose;
  }
  const middlewareEnhancer = applyMiddleware(...middleware);
  enhancers = [middlewareEnhancer, ...enhancers];
  const composedEnhancers = composeEnhancers(...enhancers);
  const store = createStore(
    reducerManager.reduce,
    preloadedState,
    composedEnhancers,
  );
  store.reducerManager = reducerManager; // replace with redux-dynamic-modules or alternative
  reduxSagaMiddleware.run(rootSaga);

  /** **************** DEPRECATED ***************** */
  /** *** do not use in functional components **** */
  /** ****** will be deleted in the future ******* */
  store.dynamicReducers = {};
  store.injectReducer = (key, dynamicReducer) => {
    if (!key || store.dynamicReducers[key]) {
      return;
    }
    // can not be deleted via store.reducerManager.remove(key)
    store.dynamicReducers[key] = dynamicReducer;
    store.replaceReducer(addDynamicReducers(staticReducers, store.dynamicReducers));
  };

  store.runSaga = reduxSagaMiddleware.run;
  store.asyncSagas = {};
  store.injectSaga = (key, asyncSaga) => {
    if (!key || store.asyncSagas[key]) {
      return;
    }
    /*
    if (store.asyncSagas[key] && store.asyncSagas[key].saga !== saga) {
      store.asyncSagas[key].task.cancel();
    }
    */
    const sagaTask = store.runSaga(asyncSaga);
    store.asyncSagas[key] = { saga: asyncSaga, task: sagaTask };
  };
  /** ******************************************** */

  /*
  // configured only for staticReducers
  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if(process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('../reducers', () => store.replaceReducer(staticReducers));
  }
  */

  return store;
};

export default configureStore;
